import { FormStatuses, TeacherRecommendationStatus } from '@youscience/commonapp-service-common';

import LabelWithDate from '@components/LabelWithDate';

import { formatDateWithFallback } from '@utils/formatter';
import { CoreTypography } from '@youscience/core';

export interface FormStatusProps {
  formStatus: FormStatuses['counselor']['forms'][0] | FormStatuses['members'][0]['teachers'][0] | undefined;
  isTeacher?: boolean;
}

export const FormStatus = ({ formStatus, isTeacher }: FormStatusProps) => {
  if (!formStatus || formStatus.status === TeacherRecommendationStatus.NOT_STARTED) {
    return isTeacher ? (
      <LabelWithDate
        label={isTeacher ? 'Teacher Evaluation' : 'Recommendation'}
        date={TeacherRecommendationStatus.NOT_STARTED}
      />
    ) : (
      <CoreTypography variant="body2">{TeacherRecommendationStatus.NOT_STARTED}</CoreTypography>
    );
  }

  if (formStatus.status === TeacherRecommendationStatus.SUBMITTED) {
    return (
      <LabelWithDate label={formStatus?.status} date={formatDateWithFallback(formStatus?.submittedDate as string)} />
    );
  }

  if (formStatus.status === TeacherRecommendationStatus.IN_PROGRESS && formStatus.modifiedDate) {
    return (
      <LabelWithDate
        label={formStatus?.status}
        date={`updated on ${formatDateWithFallback(formStatus?.modifiedDate as string)}`}
      />
    );
  }

  //TODO - show date for Pending and Rejected?

  return <CoreTypography variant="body2">{formStatus?.status}</CoreTypography>;
};
